<template>
  <!--电表-->
    <div class="meter-box" id="meter">
      <div class="meter-title">
        <div class="meter-san"></div>
        <span>强电井</span>
        <div class="close"></div>
      </div>
      <ul class="meter-list">
        <li>
          <p style="color: #249ce1">电表N1</p>
          <div class="list">
            <div class="list-top">
              <span style="color: #249ce1">1364.87</span>
              <span>kWh</span>
            </div>
            <div class="list-bottom">
              <span>2022-02-07</span>
              <span>16:57</span>
            </div>
          </div>
        </li>
        <li>
          <p style="color: #f5aa21">电表N1</p>
          <div class="list">
            <div class="list-top">
              <span style="color: #f5aa21">1364.87</span>
              <span>kWh</span>
            </div>
            <div class="list-bottom">
              <span>2022-02-07</span>
              <span>16:57</span>
            </div>
          </div>
        </li>
        <li>
          <p style="color: #b96dee">电表N1</p>
          <div class="list">
            <div class="list-top">
              <span style="color: #b96dee">1364.87</span>
              <span>kWh</span>
            </div>
            <div class="list-bottom">
              <span>2022-02-07</span>
              <span>16:57</span>
            </div>
          </div>
        </li>
      </ul>
    </div>
</template>

<script>
    export default {
        name: "Meter"
    }
</script>

<style scoped lang="less">
  .meter-box{
    position: absolute;
    top: 0;
    left: 900px;
    background: url("./../assets/meter-box.png") no-repeat;
    background-size: 100% 100%;
    width: 317px;/*no*/
    height: 177px;/*no*/
    z-index: 999;
    .meter-list{
      li{
        display: flex;
        align-items: center;
        box-sizing: border-box;
        padding-left: 36px;/*no*/
        height: 50px;/*no*/
        &:nth-of-type(2){
          background: url("./../assets/meter-list.png") no-repeat;
          background-size: 100% 100%;
          height: 45px;/*no*/
        }
        p{
          font-size: 14px;
          font-family: "SourceHanSansCNVF";
          color: rgb(36, 156, 225);
          margin-right: 64px;/*no*/
        }
        .list{
          font-size: 14px;
          font-family: "SourceHanSansCNVF";
          color: rgb(255, 255, 255);
          .list-top{
            span{
              display: inline-block;
              &:nth-of-type(1){
                width: 62px;/*no*/
              }
              &:nth-of-type(2){
                margin-left: 34px;/*no*/
              }
            }
          }
          .list-bottom{
            span{
              display: inline-block;
              &:nth-of-type(1){
                width: 62px;/*no*/
                font-size: 12px;
                font-family: "SourceHanSansCNVF";
                white-space: nowrap;
              }
              &:nth-of-type(2){
                margin-left: 34px;/*no*/
              }
            }
          }
        }
      }
    }
    .meter-title{
      background: url("./../assets/meter-title.png") no-repeat;
      background-size: 100% 100%;
      width: 317px;/*no*/
      height: 32px;/*no*/
      box-sizing: border-box;
      padding-left: 15px;/*no*/
      display: flex;
      align-items: center;
      position: relative;
      .close{
        width: 10px;
        height: 10px;
        background: url("./../assets/close.png") no-repeat;
        background-size: 100% 100%;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 9px;
        cursor: pointer;
        z-index: 999;
      }
      .meter-san{
        background: url("./../assets/meter-san.png") no-repeat;
        background-size: 100% 100%;
        width: 12px;/*no*/
        height: 8px;/*no*/
      }
      span{
        margin-left: 14px;/*no*/
        font-size: 14px;
        font-family: "SourceHanSansCNVF";
        color: rgb(255, 255, 255);
      }
    }
  }
</style>
